
export default {
  props: {
    attribute: {
      type: String,
      required: true,
    },

    placeholder: {
      type: String,
      default: '',
    },

    filterCleared: {
      type: Boolean,
      default: false,
    },

    limit: {
      type: Number,
      default: 100,
    },
  },

  data() {
    return {
      valueSelected: '',
    }
  },

  watch: {
    filterCleared(val, oldVal) {
      if (val === true) {
        this.valueSelected = ''
      }
    },
  },
}
